"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinancialChart = FinancialChart;
var _server = require("@whitbread-eos/utils/server");
var _recharts = require("recharts");
var _chart = require("../Chart/chart");
var _jsxRuntime = require("react/jsx-runtime");
function FinancialChart(_ref) {
  var {
    chartData,
    chartConfig,
    axisDataKey,
    dataTestId,
    className,
    tooltipNameKey,
    barDataKey,
    tooltipPosition = {
      x: 0,
      y: 0
    },
    activeIndex = null,
    showTooltip = false,
    disabled = false,
    formatXAxis,
    formatYAxis,
    formatTooltip,
    formatLabel,
    onMouseEnter,
    onMouseLeave
  } = _ref;
  return (0, _jsxRuntime.jsx)(_chart.ChartContainer, {
    config: chartConfig,
    className: (0, _server.cn)(className, 'relative h-[14.375rem] w-full', disabled ? 'opacity-[30%]' : '', disabled ? 'disabled' : ''),
    "data-testid": "".concat(dataTestId, "-recharts-container"),
    children: (0, _jsxRuntime.jsxs)(_recharts.BarChart, {
      accessibilityLayer: true,
      data: chartData,
      barSize: 38.83,
      overflow: 'visible',
      children: [(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
        horizontal: true,
        vertical: false
      }), (0, _jsxRuntime.jsx)(_recharts.XAxis, {
        dataKey: axisDataKey,
        tick: {
          fill: 'var(--dark-grey-1)',
          opacity: activeIndex !== null ? 0.5 : 1
        },
        tickLine: false,
        tickMargin: 10,
        axisLine: false,
        tickFormatter: formatXAxis
      }), (0, _jsxRuntime.jsx)(_recharts.YAxis, {
        type: "number",
        axisLine: false,
        tick: {
          fill: 'var(--dark-grey-1)',
          width: 250
        },
        tickFormatter: formatYAxis,
        tickLine: false,
        tickCount: 6,
        interval: 0
      }), (0, _jsxRuntime.jsx)(_chart.ChartTooltip, {
        active: showTooltip,
        labelClassName: "recharts-tooltip-label",
        position: {
          x: tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.x,
          y: tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.y
        },
        content: (0, _jsxRuntime.jsx)(_chart.ChartTooltipContent, {
          className: "text-[.875rem] leading-[1.25rem] min-w-[9.68rem] min-h-[4.87rem] rounded-sm px-[1rem] py-[.5rem] bg-[var(--tooltipInfo)]",
          nameKey: tooltipNameKey,
          formatter: formatTooltip,
          labelFormatter: formatLabel
        })
      }), (0, _jsxRuntime.jsx)(_recharts.Bar, {
        dataKey: barDataKey,
        onMouseEnter: !disabled ? onMouseEnter : undefined,
        onMouseLeave: !disabled ? onMouseLeave : undefined,
        fill: disabled ? 'var(--dark-grey-2)' : 'var(--primaryColor)',
        children: chartData === null || chartData === void 0 ? void 0 : chartData.map((entry, index) => {
          var activeCellClass = activeIndex === null ? '' : activeIndex === index ? 'active-chart-cell' : 'inactive-chart-cell';
          var lastCellClass = index === (chartData === null || chartData === void 0 ? void 0 : chartData.length) - 1 ? ' last-chart-cell' : '';
          return (0, _jsxRuntime.jsx)(_recharts.Cell, {
            cursor: !disabled ? 'pointer' : 'default',
            className: "chart-cell ".concat(activeCellClass).concat(lastCellClass),
            fill: disabled ? 'var(--dark-grey-2)' : 'var(--primaryColor)'
          }, "cell-".concat(index));
        })
      })]
    })
  });
}